import createTheme from '@signal/theme/createTheme'
import overridesModule from './overrides'

export default createTheme(overridesModule)
